// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : COMMENT LINES ADDED
// MODIFIED DATE: 05-08-2025

import LoanDisbursementActionTypes from './loan-disbursement.types';

/** ***************** GET LOAN DISBURSEMENT START *********************** */
export const getLoanDisbursementDetailsStart = (getData: any) => ({
	type: LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_START,
	payload: getData,
});

export const getLoanDisbursementDetailsSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_SUCCESS,
	payload: successData,
});

export const getLoanDisbursementDetailsFailure = (failureData: any) => ({
	type: LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_FAILURE,
	payload: failureData,
});

export const getLoanDisbursementDetailsResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_RESPONSE_RESET,
});

export const getLoanDisbursementDetailsResponseChanged = () => ({
	type: LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET LOAN DISBURSEMEN END *********************** */

/** ***************** GET OFFICER BASED ON BRANCH DETAILS START *********************** */
export const getOfficerBranchDetailsStart = (getData: any) => ({
	type: LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_START,
	payload: getData,
});

export const getOfficerBranchDetailsSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_SUCCESS,
	payload: successData,
});

export const getOfficerBranchDetailsFailure = (failureData: any) => ({
	type: LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_FAILURE,
	payload: failureData,
});

export const getOfficerBranchDetailsResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_RESPONSE_RESET,
});

export const getOfficerBranchDetailsResponseChanged = () => ({
	type: LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_RESPONSE_CHANGED,
});
/** ***************** GET OFFICER BASED ON BRANCH DETAILS END *********************** */

/** ***************** FETCH ALL PRODUCT TYPE START *********************** */
export const fetchAllEconomicActivityStart = (fetchEconomicActivitys: any) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_START,
	payload: fetchEconomicActivitys,
});

export const fetchAllEconomicActivitySuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_SUCCESS,
	payload: successData,
});

export const fetchAllEconomicActivityFailure = (failureData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_FAILURE,
	payload: failureData,
});

export const fetchAllEconomicActivityResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_RESPONSE_RESET,
});

export const fetchAllEconomicActivityResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL PRODUCT TYPE END *********************** */
